import { useUserPresenceStore } from "../../store/useUserPresenceStore";
import { useLastOnline } from "../../utils/formatTime";

const ShowTimeOffline = ({ personalDetail, languageMap, user }) => {
  const status =
    useUserPresenceStore(
      (state) => state.userStatuses?.[personalDetail?.userId],
    ) || "OFFLINE";

  const lastOnlineText = useLastOnline(
    personalDetail,
    languageMap,
    user?.language,
  );

  if (status === "ONLINE") {
    return <span>Online</span>;
  }

  return <span>{lastOnlineText}</span>;
}

export { ShowTimeOffline };
